import { usePreloadRoute } from '@repo/studio-hooks-router/use-preload-route'
import { Link } from '@repo/react-router-locale/locale-router'
import * as React from 'react'
import type { LinkProps } from 'react-router'
import { callAll } from 'utils/call-all'

export const PreloadedLink = function PreloadedLink({
  preload = true,
  ...props
}: Omit<LinkProps, 'ref'> & {
  preload?: boolean
  ref?: React.Ref<HTMLAnchorElement>
}) {
  // The preload target stays unlocalized while `Link` localizes the href, and
  // that asymmetry is deliberate: `PreloadRouteProvider` is handed the route tree
  // *before* `withLocaleRoutes` wraps it, so its paths have no locale segment and
  // `/de/video` would match nothing — a hover that preloads nothing at all. The
  // locale is a route segment, not part of a route module's identity, so `/video`
  // and `/de/video` resolve to the same chunk and loader either way.
  const { preloadRoute } = usePreloadRoute({ to: props.to, enabled: preload })

  React.useEffect(() => {
    preloadRoute?.()
  }, [preloadRoute])

  return <Link {...props} onMouseEnter={callAll(props.onMouseEnter, preloadRoute)} />
}
